import { API } from 'api';
import { useMutation } from 'react-query';

interface IAddPoints {
  payload: {
    toEid: string;
    expiredAt?: string;
    amount: number;
    ptbId?: string;
    description?: string;
    toEbid?: string;
  };
}

export const addPoints = (payload: IAddPoints['payload']) => API.post()('/api/admin/reward/transfer', payload);

export const useAddPoints = () => {
  return useMutation(addPoints, {
    onSuccess: (response) => {
      return response.data;
    },
  });
};
